<template>
  <!-- App Capsule -->
  <SideHeader :to="'/'" />

  <div style="padding-top: 55px;">
    <!-- loader -->

    <!-- * loader -->
    <div class="mb-5">
      <div class="section mt-1">
        <div class="text-center">
          <div class="avatar">
            <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar" class="imaged w64 rounded" />
          </div>
          <div v-if="profile.ratingDriver != null" class="mt-1" style="display:inline-block;">
            <star-rating :inline="true" :star-size="16" :read-only="true" :show-rating="false"
              :rating="profile.ratingDriver"></star-rating>
          </div>

        </div>
      </div>

      <ul v-if="loading" class="listview image-listview placeholder-glow mb-2">
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-primary placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-4"></span>
              <span class="placeholder col-2"></span>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-secondary placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-2"></span>
              <span class="placeholder col-1"></span>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-danger placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-5"></span>
            </div>
          </a>
        </li>
      </ul>

      <ul v-else class="listview link-listview image-listview">
        <li>
          <router-link :to="{ name: 'profileEdit' }" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="person" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                {{ profile.name }} {{ profile.lastName }}
                <footer class="text-TEAL">{{ profile.mobileNumber }}</footer>
              </div>
              <span class="text-muted">
                <div>
                  احراز هویت
                  <footer class="text-TEAL" v-if="profile.authStatus == 0">
                    {{ profile.driverAuthStatusTitles[0] }}
                  </footer>
                  <footer class="text-TEAL" v-if="profile.authStatus == 1">
                    {{ profile.driverAuthStatusTitles[1] }}
                  </footer>
                  <footer class="text-TEAL" v-if="profile.authStatus == 2">
                    {{ profile.driverAuthStatusTitles[2] }}
                  </footer>
                  <footer class="text-TEAL" v-if="profile.authStatus == 3">
                    {{ profile.driverAuthStatusTitles[3] }}
                  </footer>
                </div>
              </span>
            </div>
          </router-link>
        </li>
        <li @click="backFleet()">
          <a href="#" data-bs-toggle="offcanvas" data-bs-target="#actionSheetForm" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="car" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                ناوگان
                <footer class="text-TEAL">{{ profile.fleetTitle }}</footer>
              </div>
            </div>
            <!-- <span class="text-muted">انتخاب</span> -->
          </a>
        </li>
        <!-- <li v-if="this.freeCalls === 0">
          <a href="#" data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetContent_' + profile.id"
            @click="offPardakht" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="calendar" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                <span>خرید اشتراک</span>
                <footer class="text-TEAL">
                  روز های باقی مانده:
                  <span v-bind:class="{ 'text-danger': diffDays == 0, 'text-success': diffDays !== 0, }">{{ diffDays }}
                    روز</span>
                </footer>
              </div>
            </div>
          </a>
        </li> -->
        <li>
          <router-link to="/feedback" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="thumbs-up" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                انتقاد و شکایات
                <!-- <footer class="text-TEAL">{{ profile.fleetTitle }}</footer> -->
              </div>
            </div>
            <!-- <span class="text-muted">انتخاب</span> -->
          </router-link>
        </li>
        <li>
          <router-link to="/faq" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="help" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                سوالات متداول
              </div>
            </div>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/transaction" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="receipt" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                فهرست تراکنش ها
              </div>
            </div>
          </router-link>
        </li> -->
      </ul>
      <!-- Form Action Sheet -->
      <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
        <div class="offcanvas-header background-TEAL">
          <h5 class="offcanvas-title text-light">انتخاب ناوگان ({{ profile.fleetTitle }})</h5>
          <a href="#" id="backFleet" class="offcanvas-close" style="display: none" data-bs-dismiss="offcanvas">
            <ion-icon name="close"></ion-icon>
          </a>
        </div>
        <div class="offcanvas-body">
          <form @submit.prevent="changeFleet">
            <div class="form-group basic mb-5">
              <div class="input-wrapper">
                <div class="section full mt-2">
                  <div class="section-title" style="justify-content: center !important;">لطفا ناوگان مورد نظر خود را
                    انتخاب کنید</div>

                  <div class="accordion" id="accordionExample1">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion5">
                          نیسان و وانت
                        </button>
                      </h2>
                      <div id="accordion5" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms5" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion1">
                          کامیونت
                        </button>
                      </h2>
                      <div id="accordion1" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">

                            <div class="form-check" v-for="fleet in fleets.coms1" :key="fleet.id">
                              <input class="form-check-input" :value="fleet.id" type="radio" name="radioList"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion2">
                          کامیون 6 چرخ (تک)
                        </button>
                      </h2>
                      <div id="accordion2" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms2" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion3">
                          کامیون 10 چرخ (جفت)
                        </button>
                      </h2>
                      <div id="accordion3" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms3" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion4">
                          تریلی
                        </button>
                      </h2>
                      <div id="accordion4" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms4" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group basic" style=" position: fixed; bottom: 0;">
              <button type="submit" data-bs-dismiss="offcanvas" class="btn background-blue text-light btn-block">
                ثبت
              </button>
            </div>
          </form>
        </div>
      </div>
      <Peyment :driver_id="postData.driver_id" :data="profile.id" />
      <!-- * Form Action Sheet -->

      <div class="container">
        <div class="row g-3 mt-2 text-center">
          <div class="col-4">
            <router-link :to="{ name: 'term' }" class="btn btn-outline-success">قوانین مقررات</router-link>
          </div>
          <div class="col-4">
            <a @click="callSupport()" class="btn btn-outline-success" :href="'tel:' + tel">تماس پشتیبانی</a>
          </div>
          <div class="col-4">
            <button @click="offShare" data-bs-toggle="offcanvas" data-bs-target="#shareApp"
              class="btn btn-outline-success">
              اشتراک گذاری
            </button>
            <!-- Share Action Sheet -->
            <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="shareApp">
              <div class="offcanvas-header">
                <h5 class="offcanvas-title">اشتراک گذاری</h5>
              </div>
              <div class="offcanvas-body">
                <ul class="action-button-list">
                  <li>
                    <a @click="copy()" class="btn btn-list">
                      <span>
                        <ion-icon class="m-1" name="copy-outline"></ion-icon>
                        کپی لینک نسخه وب
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="sms:?&body=لینک مستقیم اپلیکیشن اعلام بار اس بار https://driver.s-bar.ir"
                      class="btn btn-list">
                      <span>
                        <ion-icon class="m-1" name="mail-outline"></ion-icon>
                        پیامک
                      </span>
                    </a>
                  </li>
                  
                  <li class="d-none">
                    <a id="closeShareApp" class="btn btn-list" data-bs-dismiss="offcanvas">
                      <span>
                        <!-- <ion-icon name="logo-linkedin"></ion-icon> -->
                        بستن
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- * Share Action Sheet -->
          </div>
        </div>
      </div>
      <p class="text-center mt-2">
        <a class="text-danger" href="#" @click="logout()">خروج از حساب کاربری</a>
      </p>
    </div>
  </div>
  <!-- * App Capsule -->
  <!-- <Footer v-show="isLoggedIn" /> -->

</template>
<script>
import axios from "axios";
// import { ref } from "vue";
import Swal from "sweetalert2";
import Peyment from "../../components/Peyment.vue";
import StarRating from 'vue-star-rating'
// import Header from "@/components/header.vue";
import SideHeader from "@/components/SideHeader.vue";
import router from "@/router";

export default {
  components: {
    Peyment,
    StarRating,
    SideHeader,
  },
  data() {
    return {
      postData: {
        driver_id: window.localStorage.getItem("idUser"),
        fleet_id: "",
      },
      fleets: {
        coms1: [],
        coms2: [],
        coms3: [],
        coms4: [],
        coms5: [],
      },
      tel: window.localStorage.getItem("tel"),
      time: [],
      profile: [],
      diffDays: [],
      loading: false,
      freeCalls: '',
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
      notification: {
        userType: 'driver',
        notification: ''
      },
      sms: {
        userType: 'driver',
        sms: ''
      }
    };
  },
  methods: {
    copy() {
      navigator.clipboard.writeText('https://driver.s-bar.ir');
      document.getElementById("closeShareApp").click();
    },
    callSupport() {
      axios.get("https://xpanel.s-bar.ir/api/driver/support", this.axiosConfig)
        .then((response) => {
          // console.log(response);
        });
    },
    toggleNotification() {
      this.notification.notification == 'enable' ? this.notification.notification = 'disable' : this.notification.notification = 'enable';
      axios.post("https://xpanel.s-bar.ir/api/driver/changeNotificationFunction",
        this.notification, this.axiosConfig
      );
    },
    toggleSMS() {
      this.sms.sms == 'enable' ? this.sms.sms = 'disable' : this.sms.sms = 'enable';
      axios.post("https://xpanel.s-bar.ir/api/driver/changeSmsFunction",
        this.sms, this.axiosConfig
      );
    },
    logout() {
      Swal.fire({
        title: "مایل به خروج از حساب کاربری هستید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0099c9",
        cancelButtonColor: "#0099c9",
        cancelButtonText: "خیر",
        confirmButtonText: "بله!",
      }).then((result) => {
        if (result.isConfirmed) {
          Object.keys(localStorage).forEach((key) => {
            if (!['version'].includes(key)) {
              localStorage.removeItem(key);
            }
          });
          router.push({ name: 'login' })
        }
      });
    },
    getworkorderdetail: function () {
      this.loading = true;
      let workorder = axios.get(`https://xpanel.s-bar.ir/api/driver/profile`, this.axiosConfig)
        .then((response) => {
          this.loading = false;
          this.freeCalls = response.data.data.freeCalls
          var d1 = new Date();
          var d2 = new Date(response.data.data.activeDate);
          var diff = d2.getTime() - d1.getTime();
          var daydiff = diff / (1000 * 60 * 60 * 24);
          if (daydiff < 0) {
            daydiff = 0;
          }
          this.$cookies.set("profile", { data: response.data.data }, "10min");
          this.profile = response.data.data;
          this.postData.fleet_id = this.profile.fleet_id
          // console.log(response.data.data);
          this.notification.notification = response.data.data.notification;
          this.sms.sms = response.data.data.sms;
          this.diffDays = Math.round(daydiff);
        });
      return workorder;
    },
    offShare() {
      localStorage.setItem("offShare", 1);
      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?offShare=1";
        window.history.pushState({ path: newurl }, "", newurl);

      }
    },
    offPardakht() {
      localStorage.setItem("offPardakht", this.profile.id);
      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?offPardakht=1";
        window.history.pushState({ path: newurl }, "", newurl);

      }
    },
    changeFleet() {
      axios.post(
        "https://xpanel.s-bar.ir/api/driver/changeFleet",
        this.postData, this.axiosConfig
      )
        .then((res) => {
          this.profile.fleetTitle = res.data.data.fleetTitle;
          Swal.fire({
            position: "center",
            icon: "success",
            title: "با موفقیت تغییر کرد",
            showConfirmButton: false,
            timer: 1000,
          });
        });
    },
    backFleet() {
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backFleet=1';
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }
  },
  computed: {
    isLoggedIn() {
      return window.localStorage.getItem("token");
    },
  },
  async beforeMount() {
    try {
      const response = await axios.get(
        "https://xpanel.s-bar.ir/api/requestAllFleetsLists"
      );
      // this.fleets = response.data.fleets;
      this.fleets.coms1 = response.data.data.filter(obj => obj.parent_id == 42);
      this.fleets.coms2 = response.data.data.filter(obj => obj.parent_id == 43);
      this.fleets.coms3 = response.data.data.filter(obj => obj.parent_id == 53);
      this.fleets.coms4 = response.data.data.filter(obj => obj.parent_id == 54);
      this.fleets.coms5 = response.data.data.filter(obj => obj.parent_id == 81);
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    this.getworkorderdetail();
  }
}
</script>
<style scoped>
.btn-outline-success {
    background: transparent;
    border-color: #4300FF;
    border-width: 1px !important;
    color: #4300FF;
    transition: none;
}
.item {
  border: 1px solid #f1f1f1;
}
</style>